module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": _vm.closeGallery
    }
  }, [_c('div', {
    staticClass: "overlay-content gallery-size",
    attrs: {
      "id": "gallery",
      "onclick": "event.stopPropagation();"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "alt": "",
        "src": image,
        "data-image": image
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d4fb78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/commons/util/Gallery.vue
// module id = 118
// module chunks = 0 1 2